export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_21.c72d6a7c.jpg";